<template>
  <BaseVeeForm :action="submitForm" ensure-error-keys-camel-case>
    <template #default="formProps">
      <div class="bg-gray-50 flex items-start">
        <div class="flex-1 px-6 py-4">
          <ValidationProvider rules="required" name="status" slim vid="status">
            <template #default="{ errors }">
              <BaseFormGroup>
                <BaseFormSelect
                  v-model="formData.status"
                  :options="statusOptions"
                  :disabled="disabled"
                  required
                  class="w-full"
                />
                <BaseFormInlineMessage v-if="errors.length" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </template>
          </ValidationProvider>
        </div>
        <div class="flex-1 px-6 py-4">
          <ValidationProvider rules="required" name="series" slim vid="series">
            <template #default="{ errors }">
              <BaseFormGroup>
                <BaseFormSelect
                  v-model="formData.series"
                  :options="seriesOptions"
                  :disabled="disabled"
                  required
                  class="w-full"
                />
                <BaseFormInlineMessage v-if="errors.length" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </template>
          </ValidationProvider>
        </div>
        <div class="w-40 px-6 py-4">
          <button
            type="submit"
            class="w-full inline-flex items-center px-4 py-2 border text-sm justify-center font-medium rounded-md bg-white focus:outline-none disabled:border-transparent disabled:text-gray-500 border-gray-300 text-gray-700 hover:bg-gray-50 focus:border-blue-600"
            :disabled="disabled || formProps.isPending || formProps.invalid"
          >
            Create
          </button>
        </div>
      </div>
    </template>
  </BaseVeeForm>
</template>

<script>
import { softOneApiServiceConfigAccOrderStatusesClient } from '@/api/clients';

const defaultFormData = {
  status: null,
  series: '',
};

export default {
  props: {
    softOneServiceId: {
      type: String,
      required: true,
    },
    seriesOptions: {
      type: Array,
      default: () => [],
    },
    statusOptions: {
      type: Array,
      default: () => [],
    },
    disabled: Boolean,
  },
  data() {
    return {
      formData: {
        ...defaultFormData,
      },
    };
  },
  methods: {
    async submitForm() {
      try {
        await this.$store.dispatch('ui/thirdPartyServices/updateFromService', {
          id: this.softOneServiceId,
          formData: { ...this.formData },
          service: softOneApiServiceConfigAccOrderStatusesClient.store,
        });

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
